var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnTimeDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7345 9.96863C18.2032 9.96863 13.703 14.4687 13.703 20C13.703 25.5314 18.2032 30.0314 23.7345 30.0314C29.2658 30.0314 33.7659 25.5314 33.7659 20C33.7659 14.4687 29.2658 9.96863 23.7345 9.96863ZM28.4648 21.1719H22.5626V12.946H24.9064V18.8282H28.4648V21.1719Z",
    fill: "#1A1818"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7792 3.73456C20.2105 3.72495 16.9091 4.86542 14.223 6.80503H5.35344C3.95508 6.80503 2.82156 7.93862 2.82156 9.3369C2.82156 10.7353 3.95516 11.8688 5.35344 11.8688H9.64445C8.82687 13.2825 8.21664 14.8309 7.85359 16.4722H2.53188C1.13359 16.4723 0 17.6058 0 19.0042C0 20.4025 1.13359 21.536 2.53188 21.536H7.54156C7.69281 23.1508 8.08016 24.6967 8.66875 26.1395H6.86031C5.46195 26.1395 4.32844 27.2731 4.32844 28.6714C4.32844 30.0697 5.46203 31.2032 6.86031 31.2032H11.9427C14.9061 34.3214 19.0931 36.2655 23.7345 36.2655C32.7177 36.2656 40 28.9833 40 20.0001C40 11.0132 32.7661 3.75878 23.7792 3.73456ZM23.7345 32.3752C16.9108 32.3752 11.3593 26.8237 11.3593 20C11.3593 13.1764 16.9108 7.62487 23.7345 7.62487C30.5581 7.62487 36.1096 13.1764 36.1096 20C36.1096 26.8237 30.5581 32.3752 23.7345 32.3752Z",
    fill: "#1A1818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnTimeDelivery);
export default __webpack_public_path__ + "static/media/on-time-delivery.f7e6348802cc4109b63b32d43c7775da.svg";
export { ForwardRef as ReactComponent };